import Pusher from "pusher-js";
export const pusher = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
    wsHost: import.meta.env.VITE_PUSHER_HOST,
    wsPort: import.meta.env.VITE_PUSHER_PORT,
    wssPort: import.meta.env.VITE_PUSHER_PORT_SSL,
    forceTLS: import.meta.env.VITE_PUSHER_FORCE_TLS === 'true',
});
